import {useProperties} from '../../SidePanel/RightPanel/Properties.mjs'

import {
    PropertiesController,
    usePropertiesController,
} from '../../SidePanel/RightPanel/PropertiesController.jsx'

import SelectSs from '../SS/SelectSs.jsx'

export default function PropertiesControllerSs({
    className,
    style,
    codeProp = 'ssCode',
    disabled,
    hidden,
    idProp = 'ssId',
    isUi,
    label,
    labelSuffix,
    nameProp = 'ssName',
    readOnly,
    required,
    ...props
}) {
    const [values, update] = useProperties()

    const {
        [codeProp]: ssCode,
        [idProp]: ssId,
        [nameProp]: ssName,
    } = values

    const handleChange = ss => {
        const {
            ssCode = '',
            ssId = '',
            ssName = '',
            terminalType,
        } = ss ?? {}

        update({
            [codeProp]: ssCode,
            [idProp]: ssId,
            [nameProp]: ssName,
            terminalType,
        })
    }

    const p = usePropertiesController({
        disabled,
        hidden,
        label,
        prop: codeProp,
        readOnly,
        required,
    })

    return (
        <PropertiesController
            className={className}
            style={style}
            hidden={p.hidden}
            label={p.label}
            labelSuffix={labelSuffix}
            required={p.required}
        >
            <SelectSs
                isLeaf={false}
                disabled={p.disabled}
                isUi={isUi}
                readOnly={p.readOnly}
                value={{ssCode, ssId, ssName}}
                onChange={handleChange}
                {...props}
            />
        </PropertiesController>
    )
}
